import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import DateRangeIcon from '@mui/icons-material/DateRange'
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyles'
// import { DateRange } from 'react-date-range'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { es } from 'date-fns/locale'
import { updateApplicationInstanceAppModule } from '../../../../app/services/eAuthz/updateApplicationInstanceAppModuleEAuthz'
import { useNavigate, useParams } from 'react-router-dom'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../redux/actions/app'
import { useDispatch } from 'react-redux'
import { logEvent } from '../../../../utils/LogEvents'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 225,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const EditModule = ({ module }) => {
  const classes = useStyles()
  // const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [openModal, setopenModal] = useState(false)
  const { id } = useParams()
  const [showCircularProgress, setshowCircularProgress] = useState(false)

  const handleOpen = () => {
    setopenModal(true)
  }
  const formatDate = (date) => {
    let formattedDate

    if (date) {
      const newDate = new Date(date)
      formattedDate = {
        day: newDate.getUTCDate(),
        mounth: newDate.getUTCMonth(),
        year: newDate.getUTCFullYear()
      }
    }

    return formattedDate
  }

  const [selectedDateStart, setSelectedDateStart] = useState(
    module.startDate
      ? new Date(
        formatDate(module.startDate).year,
        formatDate(module.startDate).mounth,
        formatDate(module.startDate).day
      )
      : null
  )
  const [selectedDateFinish, setSelectedDateFinish] = useState(
    module.finishDate
      ? new Date(
        formatDate(module.finishDate).year,
        formatDate(module.finishDate).mounth,
        formatDate(module.finishDate).day
      )
      : null
  )

  const handleDateStartChange = (date) => {
    setSelectedDateStart(date)
  }
  const handleDateFinishChange = (date) => {
    setSelectedDateFinish(date)
  }
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const addModule = async () => {
    setshowCircularProgress(true)
    try {
      if (!selectedDateStart) {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Seleccione una fecha de inicio'))
        return
      }
      const currentDate = new Date()
      if (selectedDateFinish && selectedDateFinish < selectedDateStart) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'La fecha de finalización debe ser posterior a la fecha de inicio'
          )
        )
        return
      }
      if (selectedDateFinish && selectedDateFinish < currentDate) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'La fecha de finalización debe ser posterior a hoy'
          )
        )
        return
      }

      const body = {
        applicationInstanceId: id,
        appModuleCode: module.appModule,
        startDate: selectedDateStart && selectedDateStart.toISOString(),
        finishDate: selectedDateFinish
          ? selectedDateFinish.toISOString()
          : null,
        subscriptionTypeRefCode: null
      }
      const response = await updateApplicationInstanceAppModule(body)
      logEvent('CGI - updateApplicationInstanceAppModule', {
        body: body,
        response: response
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Actualización exitosa'))
      setTimeout(() => {
        navigate(0)
      }, 1000)
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar('Ocurrió un error en un servicio de: eAuthzAPI')
      )
    } finally {
      setshowCircularProgress(false)
    }
  }
  return (
    <>
      <button className={classes.buttonEditModule} onClick={handleOpen}>
        <Typography className={classes.typographyButton}>Editar</Typography>
      </button>
      <Modal open={openModal} onClose={() => setopenModal(false)}>
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={() => setopenModal(false)}
            />
          </div>

          <div style={{ display: 'flex' }}>
            <Typography sx={{ color: '#263057', fontSize: '1.3em' }}>
              Editar periodo de habilitación del {module.appModuleName}
            </Typography>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '5%',
              marginTop: 20
            }}
          >
            <DateRangeIcon sx={{ color: '#263057', fontSize: '3em' }} />
            <div style={{ width: '80%' }}>
              <div style={{ display: 'flex' }}>
                <Typography sx={{ color: '#263057', width: '20%' }}>
                  Desde:
                </Typography>

                <div
                  style={{
                    width: '70%'
                  }}
                >
                  <DatePicker
                    id="date"
                    selected={selectedDateStart}
                    onChange={handleDateStartChange}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/aaaa"
                    showYearDropdown
                    scrollableYearDropdown
                    locale={es}
                  />
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <Typography sx={{ color: '#263057', width: '20%' }}>
                  Hasta:
                </Typography>
                <div
                  style={{
                    width: '70%'
                  }}
                >
                  <DatePicker
                    id="date"
                    selected={selectedDateFinish}
                    onChange={handleDateFinishChange}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/aaaa"
                    showYearDropdown
                    scrollableYearDropdown
                    locale={es}
                  />
                </div>
              </div>
            </div>
          </div>

          <Box className={classes.buttons} style={{ marginLeft: '45%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              addModule={addModule}
            />

            <ButtonClose handleClose={() => setopenModal(false)} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm ({ showCircularProgress, addModule }) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = async () => {
    if (!isProgressComplete) {
      try {
        await addModule()
        setProgressComplete(true)
      } catch (error) {
        setProgressComplete(false)
      }
    }
  }

  useEffect(() => {
    if (isProgressComplete) {
      const timeout = setTimeout(() => {
        setProgressComplete(false)
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [isProgressComplete])

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ''
        }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress
          ? (
          <CircularProgress size="1.5rem" color="inherit" />
            )
          : (
          <Typography className={classes.confirmButtonTypography}>
            Editar
          </Typography>
            )}
      </button>
    </div>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
